<template>
  <div class="login-page-container">

    <div class="brand-section">
      <div class="brand-content">
        <!-- 【修改点 1】：使用 require() 引用 assets 中的图片 -->
        <!-- 这样 Webpack 才能正确打包并找到图片 -->


        <h1 class="brand-title">广东省青年科技创新研究会</h1>
        <p class="brand-subtitle">
          会员管理系统
        </p>
        <p class="brand-description">
          推动青年科技创新 · 促进学术交流 · 培养创新人才
        </p>
      </div>
      <div class="bg-circle circle-1"></div>
      <div class="bg-circle circle-2"></div>
    </div>

    <div class="form-section">
      <div class="form-wrapper">
        <div class="form-header">
          <h2>欢迎回来</h2>
          <p class="sub-text">请登录您的账户以继续</p>
        </div>

        <el-card shadow="always" class="login-card">
          <el-form
            @submit.prevent="handleLogin"
            label-position="top"
            size="large"
          >
            <el-form-item label="用户名 (您的会员号)">
              <el-input
                v-model="username"
                placeholder="请输入会员号"
                prefix-icon="User"
              />
            </el-form-item>

            <el-form-item label="密码">
              <el-input
                v-model="password"
                type="password"
                placeholder="请输入密码"
                show-password
                prefix-icon="Lock"
              />
            </el-form-item>

            <el-button
              type="primary"
              native-type="submit"
              class="login-btn"
              :loading="isLoading"
            >
              {{ isLoading ? '登录中...' : '登 录' }}
            </el-button>
          </el-form>

          <div class="login-footer mt-3">
            <el-button link type="primary" @click="$router.push('/forgot-password')">
              忘记密码?
            </el-button>

            <el-divider direction="vertical" />

            <div class="register-text-group">
              <span class="sub-text">还没有账号?</span>
              <el-button link type="primary" @click="$router.push('/#how-to-join')">
                如何加入
              </el-button>
            </div>
          </div>
        </el-card>

        <p class="copyright-text mt-4 sub-text">
          &copy; {{ new Date().getFullYear() }} 广东省青年科技创新研究会
        </p>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LoginView',
  data() {
    return {
      username: '',
      password: '',
      isLoading: false,
    };
  },
  methods: {
    async handleLogin() {
      this.isLoading = true;
      try {
        // API 路径
        const response = await axios.post('/members/api/auth/login/', {
          username: this.username,
          password: this.password,
        });
        const token = response.data.token;

        localStorage.setItem('authToken', token);

        const dashboardResponse = await axios.get('/members/api/dashboard/', {
          headers: { 'Authorization': `Token ${token}` }
        });

        localStorage.setItem('isStaff', dashboardResponse.data.is_staff ? 'true' : 'false');

        this.$message.success('登录成功，欢迎回来！');
        this.$router.push('/home');

      } catch (error) {
        console.error('登录失败:', error);
        this.$message.error('登录失败，请检查用户名或密码。');
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-page-container {
  display: flex;
  min-height: 100vh;
  width: 100%;
  background-color: #fff;
  overflow: hidden;
}

/* --- 左侧：品牌区域 --- */
.brand-section {
  flex: 1.2;

  /* 【修改点 2】: 这里改回了 .jpg (如果是png请手动改回) */
  /* 使用了 ~@ 指向 src/assets 目录 */
  background: url('~@/assets/login-bg.png');

  background-size: cover;
  /* 背景图位置调整 */
  background-position: center bottom;

  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  color: #fff;
  padding: 40px;

  /* 这里的 padding-top 决定了文字和Logo整体下移的距离 */
  padding-top: 150px;

  overflow: hidden;
}

.brand-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 600px;
  margin-top: 100px;
}

/* Logo 样式：适合透明背景图 */
.brand-logo {
  width: 60px; /* 控制 Logo 大小 */
  height: auto;
  margin-bottom: 20px;
  /* 加一点投影让透明Logo更有立体感 */
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.3));
}

.brand-title {
  font-size: 2.8rem;
  font-weight: 700;
  margin-bottom: 10px;
  letter-spacing: 1px;
  text-shadow: 0 2px 10px rgba(0,0,0,0.8);
}

.brand-subtitle {
  font-size: 1.5rem;
  font-weight: 300;
  opacity: 0.9;
  margin-bottom: 30px;
  letter-spacing: 4px;
  text-transform: uppercase;
}

.brand-description {
  font-size: 1.1rem;
  opacity: 0.8;
  border-top: 1px solid rgba(255,255,255,0.3);
  padding-top: 20px;
  display: inline-block;
}


/* --- 右侧：表单区域 --- */
.form-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  position: relative;
}

.form-wrapper {
  width: 100%;
  max-width: 450px;
  padding: 40px;
}

.form-header {
  text-align: center;
  margin-bottom: 30px;
}
.form-header h2 {
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.sub-text {
  color: var(--el-text-color-secondary);
  font-size: 0.9rem;
}

.login-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08) !important;
}

.login-btn {
  width: 100%;
  padding: 12px 20px;
  font-size: 1.1rem;
  margin-top: 10px;
  height: 45px;
  letter-spacing: 2px;
}

.login-footer {
  display: flex;
  justify-content: center;
  align-items: baseline;
  font-size: 0.9rem;
  margin-top: 20px;
}
.register-text-group {
  display: flex;
  align-items: baseline;
}
.register-text-group span {
  margin-right: 5px;
}

.copyright-text {
  text-align: center;
  font-size: 0.85rem;
  margin-top: 30px;
}

/* 分割线样式 */
.login-footer :deep(.el-divider--vertical) {
  border-left: 1px solid var(--el-text-color-secondary);
  height: 1.1rem;
  align-self: center;
}

/* 移动端适配 */
@media (max-width: 992px) {
  .login-page-container {
    flex-direction: column;
  }
  .brand-section {
    flex: none;
    height: 200px;
    padding: 20px;
    padding-top: 0; /* 移动端取消下推 */
    background-position: center center;
  }
  .brand-logo {
    width: 80px;
    margin-bottom: 10px;
  }
  .brand-title {
    font-size: 1.5rem;
  }
  .brand-subtitle, .brand-description, .bg-circle {
    display: none;
  }
  .form-section {
    flex: 1;
    background-color: #fff;
  }
  .form-wrapper {
    padding: 20px;
  }
  .login-card {
    box-shadow: none !important;
  }
}
</style>